"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
const Clock_1 = tslib_1.__importDefault(require("../Icons/Clock"));
const styles_1 = tslib_1.__importDefault(require("./styles"));
const DurationLabel = ({ children, classes = {}, ...rest }) => {
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "durationLabel");
    return (react_1.default.createElement("div", { className: mergedClasses.root },
        react_1.default.createElement(Clock_1.default, null)));
};
exports.default = DurationLabel;
//# sourceMappingURL=index.js.map